import { render } from "./BaseList.vue?vue&type=template&id=af8467a6"
import script from "./BaseList.vue?vue&type=script&lang=js"
export * from "./BaseList.vue?vue&type=script&lang=js"

import "./BaseList.vue?vue&type=style&index=0&id=af8467a6&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__